"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinSchema = exports.allPinTypes = void 0;
/* eslint-disable @typescript-eslint/no-empty-interface */
const zod_1 = require("zod");
const quiz_pin_1 = require("./quiz-pin");
const slide_pin_1 = require("./slide-pin");
const video_pin_1 = require("./video-pin");
const word_cloud_pin_1 = require("./word-cloud-pin");
const placeholder_pins_1 = require("./placeholder-pins");
const open_question_pin_1 = require("./open-question-pin");
exports.allPinTypes = [
    'MULTIPLE_CHOICE',
    'SLIDE',
    'OPEN_QUESTION',
    'WORD_CLOUD',
    'DRAG_QUESTION',
    'VIDEO',
    'LINK',
    'MAP',
    'POLL',
];
exports.PinSchema = zod_1.z.discriminatedUnion('type', [
    quiz_pin_1.QuizPinSchema,
    slide_pin_1.SlidePinSchema,
    open_question_pin_1.OpenQuestionPinSchema,
    word_cloud_pin_1.WordCloudPinSchema,
    placeholder_pins_1.DragQuestionPinSchema,
    video_pin_1.VideoPinSchema,
    placeholder_pins_1.LinkPinSchema,
    placeholder_pins_1.MapPinSchema,
    placeholder_pins_1.PollPinSchema,
]);
// If this gives you an error, update the PinSchema union
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ensureTypesAreInSync = true;
//# sourceMappingURL=pin.js.map